import { Button } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';

type Props = {
  action?: () => void;
  text: string;
  height?: string;
};

const Wrap = styled.div`
  .btn {
    border-radius: 5px;
    background: #ff8a00;
    color: white;
    border: 1px solid #ff8a00;
    :hover {
      border: 1px solid #ff8a00;
      color: #ff8a00;
      background-color: white;
      transition-duration: 500ms;
    }
  }
`;

const MiniButton: FC<Props> = ({ height, action, text }) => {
  return (
    <Wrap>
      <Button style={{ height: `${height ? height : 'auto'}` }} onClick={action} className="btn standardFont">
        {text}
      </Button>
    </Wrap>
  );
};

export default MiniButton;
